import React, { useState } from 'react';
import styled from 'styled-components';
import PC from '../assets/img/png/laptop_home_page_560.webp';
import OrderModal from './OrderModal';
import LiveChatbot from '../assets/json_lottie/LiveChatbot';
import BusinesLogo from '../assets/json_lottie/BusinesLogo';
import Tessera from '../assets/json_lottie/Tessera_logo';
import { useNavigate } from 'react-router-dom';
import Analis from '../assets/img/interfaceSvg/search.svg';
import Projecting from '../assets/img/interfaceSvg/projecting.svg';
import Dev from '../assets/img/interfaceSvg/developing.svg';
import Launching from '../assets/img/interfaceSvg/launch.svg';
import Testing from '../assets/img/interfaceSvg/testing.svg';
import { useTranslation } from 'react-i18next';
/* ===================== WRAPPER ===================== */

const Wrapper = styled.section`
  width: min(100%, 1800px);
  margin: 28px auto 0;
  padding: 0px;

  /* Tablets */
  @media (max-width: 1024px) {
    margin-top: 18px;
    padding: 0 16px;
  }

  /* Phones */
  @media (max-width: 480px) {
    margin-top: 1rem;
    padding: 0px;
  }

  /* Very small phones */
  @media (max-width: 360px) {
    margin-top: 12px;
    padding: 0px;
  }

  /* Landscape phones / small tablets */
  @media (max-height: 480px) and (orientation: landscape) {
    margin-top: 12px;
    padding: 0px;
  }
`;

/* ===================== HERO CARD ===================== */

const Card = styled.div`
  position: relative;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.85);
  border-radius: 50px;
  padding: 44px 46px;
  box-shadow: 0 4px 6px rgba(241, 134, 13, 0.79);

  @media (max-width: 1100px) {
    padding: 36px 34px;
  }

  @media (max-width: 900px) {
    padding: 32px 26px;
    border-radius: 50px;
  }

  /* Tablets portrait */
  @media (max-width: 768px) {
    padding: 28px 20px;
    border-radius: 50px;
  }

  @media (max-width: 480px) {
    padding: 26px 18px;
    border-radius: 50px;
  }

  /* Landscape phones: меньше вертикальных отступов, чтобы всё влезало */
  @media (max-height: 480px) and (orientation: landscape) {
    padding: 20px 16px;
    border-radius: 50px;
  }
`;

const Grid = styled.div`
  position: relative;
  z-index: 1;

  display: grid;
  grid-template-columns: 1fr 520px;
  align-items: center;
  gap: 28px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 420px;
  }

  /* Tablet landscape */
  @media (max-width: 1024px) and (orientation: landscape) {
    grid-template-columns: 1fr 380px;
    gap: 20px;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    text-align: left;
  }

  /* Phones portrait */
  @media (max-width: 480px) {
    gap: 18px;
  }

  /* Landscape phones: чтобы не было огромного изображения и всё не “выталкивало” контент */
  @media (max-height: 480px) and (orientation: landscape) {
    grid-template-columns: 1fr 300px;
    gap: 14px;
    align-items: start;
  }
`;

const Left = styled.div`
  min-width: 0;
`;

const Title = styled.h1`
  margin: 0 0 14px;
  color: #ffffff;
  font-size: 44px;
  line-height: 1.08;
  font-weight: 800;

  @media (max-width: 1100px) {
    font-size: 40px;
  }

  @media (max-width: 900px) {
    font-size: 36px;
  }

  @media (max-width: 768px) {
    font-size: 34px;
  }

  @media (max-width: 480px) {
    font-size: 32px;
    text-align: center;
    line-height: 1.06;
  }

  @media (max-width: 360px) {
    font-size: 28px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    font-size: 28px;
    line-height: 1.05;
    margin-bottom: 10px;
  }
`;

const Subtitle = styled.p`
  margin: 0 0 22px;
  max-width: 720px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px;
  line-height: 1.55;

  @media (max-width: 768px) {
    font-size: 14px;
    max-width: 640px;
  }

  @media (max-width: 480px) {
    text-align: center;
    font-size: 13px;
    margin-bottom: 18px;
  }

  @media (max-width: 360px) {
    font-size: 12.5px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    font-size: 12.5px;
    margin-bottom: 12px;
    line-height: 1.45;
  }
`;

const Buttons = styled.div`
  display: flex;
  gap: 14px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 12px;
  }

  @media (max-width: 480px) {
    justify-content: center;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    gap: 10px;
  }
`;

const Btn = styled.button`
  border: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;

  padding: 14px 22px;
  border-radius: 999px;

  transition: 0.2s ease;

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    padding: 13px 20px;
  }

  @media (max-width: 480px) {
    padding: 12px 18px;
    font-size: 13px;
  }

  @media (max-width: 360px) {
    padding: 11px 16px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    padding: 10px 16px;
    font-size: 13px;
  }
`;

const BtnDark = styled(Btn)`
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);

  &:hover {
    opacity: 0.92;
  }
`;

const BtnAccent = styled(Btn)`
  background: #b7ff53;
  color: #0b0b0b;
  box-shadow: 0 10px 24px rgba(183, 255, 83, 0.25);

  &:hover {
    opacity: 0.92;
  }
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (max-width: 900px) {
    justify-content: center;
    margin-top: 14px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    justify-content: flex-end;
    margin-top: 0;
  }
`;

const Image = styled.img.attrs({ width: 560, height: 560 })`
  width: 100%;
  max-width: 520px;
  height: auto;
  filter: drop-shadow(0 14px 26px rgba(0, 0, 0, 0.55));

  @media (max-width: 1100px) {
    max-width: 420px;
  }

  @media (max-width: 900px) {
    max-width: 520px;
  }

  @media (max-width: 768px) {
    max-width: 440px;
  }

  @media (max-width: 480px) {
    max-width: 320px;
  }

  @media (max-width: 360px) {
    max-width: 280px;
  }

  /* Landscape phones: ограничиваем высотой, чтобы картинка не съедала экран */
  @media (max-height: 480px) and (orientation: landscape) {
    max-width: 300px;
    max-height: 220px;
    width: auto;
  }
`;

/* ===================== SERVICES ===================== */

const ServicesSection = styled.section`
  max-width: 1800px;
  margin: 2.5rem auto 0;
  padding: 40px 24px 32px;
  background-color: #f9f9f9;
  border-radius: 50px;

  @media (max-width: 1024px) {
    margin-top: 2rem;
    padding: 34px 20px 28px;
    border-radius: 40px;
  }

  @media (max-width: 768px) {
    padding: 28px 18px 24px;
    border-radius: 34px;
  }

  @media (max-width: 480px) {
    padding: 22px 14px 18px;
    border-radius: 28px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    margin-top: 1.4rem;
    padding: 20px 14px 16px;
    border-radius: 24px;
  }
`;

const ServicesTitle = styled.h2`
  text-align: left;
  margin-bottom: 1rem;
  font-size: 28px;
  color: #053969;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

const ServicesSubtitle = styled.p`
  text-align: left;
  max-width: 800px;
  margin-bottom: 2rem;
  font-size: 15px;
  color: #555;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 1.4rem;
  }

  @media (max-width: 480px) {
    font-size: 13.5px;
    margin-bottom: 1.2rem;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    margin-bottom: 1rem;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 24px;

  /* Tablet: лучше 2 колонки, чтобы карточки не становились слишком узкими */
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
  }

  /* Phones: 1 колонка (надёжно для всех ширин) */
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  /* Landscape phones: 2 колонки, если высота маленькая (выглядит аккуратнее) */
  @media (max-height: 480px) and (orientation: landscape) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
`;

const ServiceCard = styled.div`
  background-color: #ffffff;
  border-radius: 24px;
  padding: 20px 16px;
  text-align: center;
  box-shadow: 0 8px 12px rgba(11, 11, 11, 0.53);

  @media (max-width: 768px) {
    padding: 18px 14px;
    border-radius: 20px;
  }

  @media (max-width: 480px) {
    padding: 16px 12px;
    border-radius: 18px;
  }
`;

const ServiceIcon = styled.div`
  height: 120px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: 110px;
  }

  @media (max-width: 480px) {
    height: 96px;
    margin-top: 10px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    height: 84px;
    margin-top: 6px;
  }
`;

const ServiceTitle = styled.h3`
  margin: 50px 0 8px;
  font-size: 18px;
  color: #053969;

  @media (max-width: 768px) {
    margin-top: 36px;
    font-size: 17px;
  }

  @media (max-width: 480px) {
    margin-top: 28px;
    font-size: 16px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    margin-top: 18px;
  }
`;

const ServiceText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #555;

  @media (max-width: 480px) {
    font-size: 13px;
    line-height: 1.45;
  }
`;

/* -------- ПРОЦЕСС РАБОТЫ -------- */

const ProcessSection = styled.section`
  max-width: 1800px;
  margin: 3rem auto 0;
  padding: 32px 24px 40px;

  border-radius: 0px 0px 50px 50px;

  @media (max-width: 1024px) {
    margin-top: 2.2rem;
    padding: 28px 18px 34px;
    border-radius: 0px 0px 40px 40px;
  }

  @media (max-width: 768px) {
    margin-top: 2rem;
    padding: 24px 16px 28px;
    border-radius: 0px 0px 34px 34px;
  }

  @media (max-width: 480px) {
    margin-top: 1.6rem;
    padding: 20px 12px 24px;
    border-radius: 0px 0px 28px 28px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    margin-top: 1.2rem;
    padding: 18px 12px 18px;
    border-radius: 0px 0px 24px 24px;
  }
`;

const ProcessTitle = styled.h2`
  margin: 0 0 20px;
  font-size: 26px;
  color: #ffffffff;

  @media (max-width: 768px) {
    font-size: 22px;
    margin-bottom: 16px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    margin-bottom: 14px;
  }
`;

const ProcessRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
  }
`;

const IconsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  padding: 30px;

  @media (max-width: 900px) {
    padding: 0;
    gap: 18px;
  }

  /* Tablet */
  @media (max-width: 768px) {
    gap: 14px;
  }

  /* Phones: центрируем и равномерно раскладываем */
  @media (max-width: 480px) {
    justify-content: center;
    gap: 12px;
  }

  @media (max-width: 320px) {
    gap: 10px;
  }

  /* Landscape phones */
  @media (max-height: 480px) and (orientation: landscape) {
    gap: 12px;
  }
`;

const ProcessIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #111;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const IconCircle = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background-color: #0b2842;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    width: 64px;
    height: 64px;
  }

  @media (max-width: 480px) {
    width: 58px;
    height: 58px;
  }

  @media (max-width: 360px) {
    width: 54px;
    height: 54px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    width: 52px;
    height: 52px;
    margin-bottom: 6px;
  }
`;

const ImageProcess = styled.img`
  width: 32px;
  height: 32px;
  filter: brightness(0) invert(1);

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
  }

  @media (max-width: 480px) {
    width: 26px;
    height: 26px;
  }

  @media (max-height: 480px) and (orientation: landscape) {
    width: 24px;
    height: 24px;
  }
`;

const ProcessLabel = styled.span`
  margin-top: 4px;
  color: #ffffff;

  @media (max-width: 480px) {
    margin-top: 3px;
  }
`;

/* ===================== COMPONENT ===================== */

export default function Hero({ heroData }) {
  const [orderOpen, setOrderOpen] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('it') ? 'it' : 'en';

  return (
    <Wrapper>
      <Card style={{ background: heroData?.card_bg || 'rgba(0,0,0,0.85)' }}>
        <Grid>
          <Left>
            {/* <Title>{heroData?.title || 'We develop websites from ZERO!!!'}</Title> */}
            <Title>{t('hero.heroTitle')}</Title>

            <Subtitle>{t('hero.subtitle')}</Subtitle>

            <Buttons>
              {(heroData?.buttons || [])
                .filter((b) => b.is_active)
                .sort((a, b) => (a.sort || 0) - (b.sort || 0))
                .map((b) => (
                  <BtnAccent
                    key={b.id}
                    type="button"
                    onClick={() => {
                      if (b.action === 'open_modal') {
                        setOrderOpen(true);
                      } else {
                        const url = b.url || '/';
                        if (url.startsWith('http://') || url.startsWith('https://')) {
                          window.open(url, '_blank', 'noopener,noreferrer');
                        } else {
                          navigate(url);
                        }
                      }
                    }}
                    style={{ background: heroData?.button_color || '#b7ff53' }}
                  >
                    {lang === 'it' ? b.title_it : b.title_en}
                  </BtnAccent>
                ))}
            </Buttons>
          </Left>

          <Right>
            <Image src={PC} alt="Пример сайта" />
          </Right>
        </Grid>

        <ServicesSection>
          <ServicesTitle>{t('hero.serviceTitle')}</ServicesTitle>
          <ServicesSubtitle>{t('hero.serviceSubtitle')}</ServicesSubtitle>

          <ServicesGrid>
            <ServiceCard
              onClick={() => navigate('/catalog?cat=single-page-websites')}
              style={{ cursor: 'pointer' }}
            >
              <ServiceIcon>
                <Tessera />
              </ServiceIcon>
              <ServiceTitle>{t('hero.serviceList.customWebsites')}</ServiceTitle>
              <ServiceText>{t('hero.serviceList.customWebsitesSubtitle')}</ServiceText>
            </ServiceCard>

            <ServiceCard
              onClick={() => navigate('/catalog?cat=corporate-sites')}
              style={{ cursor: 'pointer' }}
            >
              <ServiceIcon>
                <LiveChatbot />
              </ServiceIcon>
              <ServiceTitle>{t('hero.serviceList.corporateWebsites')}</ServiceTitle>
              <ServiceText>{t('hero.serviceList.corporateWebsitesSubtitle')}</ServiceText>
            </ServiceCard>

            <ServiceCard
              onClick={() => navigate('/catalog?cat=market-places')}
              style={{ cursor: 'pointer' }}
            >
              <ServiceIcon>
                <BusinesLogo />
              </ServiceIcon>
              <ServiceTitle>{t('hero.serviceList.internetStores')}</ServiceTitle>
              <ServiceText>{t('hero.serviceList.internetStoresSubtitle')}</ServiceText>
            </ServiceCard>
          </ServicesGrid>
        </ServicesSection>

        <ProcessSection>
          <ProcessTitle>{t('hero.processTitle')}</ProcessTitle>

          <ProcessRow>
            <IconsRow>
              <ProcessIcon>
                <IconCircle>
                  <ImageProcess src={Analis} alt="Анализ" />
                </IconCircle>
                <ProcessLabel>{t('hero.icon1_title')}</ProcessLabel>
              </ProcessIcon>

              <ProcessIcon>
                <IconCircle>
                  <ImageProcess src={Projecting} alt="Проектирование" />
                </IconCircle>
                <ProcessLabel>{t('hero.icon2_title')}</ProcessLabel>
              </ProcessIcon>

              <ProcessIcon>
                <IconCircle>
                  <ImageProcess src={Dev} alt="Разработка" />
                </IconCircle>
                <ProcessLabel>{t('hero.icon3_title')}</ProcessLabel>
              </ProcessIcon>

              <ProcessIcon>
                <IconCircle>
                  <ImageProcess src={Testing} alt="Тестирование" />
                </IconCircle>
                <ProcessLabel>{t('hero.icon4_title')}</ProcessLabel>
              </ProcessIcon>

              <ProcessIcon>
                <IconCircle>
                  <ImageProcess src={Launching} alt="Запуск" />
                </IconCircle>
                <ProcessLabel>{t('hero.icon5_title')}</ProcessLabel>
              </ProcessIcon>
            </IconsRow>
          </ProcessRow>
        </ProcessSection>
        <OrderModal open={orderOpen} onClose={() => setOrderOpen(false)} />
      </Card>
    </Wrapper>
  );
}
